import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
  imageUrl: string;
}

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  crumbs,
  imageUrl,
}: PageHeroProps) {
  return (
    <section className="relative pt-24 md:pt-28">
      <div className="relative h-[260px] md:h-[340px] w-full overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-900/70 to-primary-800/60" />
        <div className="absolute inset-0 bp-grid opacity-15" />
        <div className="relative h-full max-w-7xl mx-auto px-4 md:px-8 flex flex-col justify-center">
          {eyebrow && (
            <span className="inline-flex w-fit items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-200 mb-3">
              <span className="w-6 h-px bg-accent-300" />
              {eyebrow}
            </span>
          )}
          <h1 className="text-3xl md:text-5xl font-heading font-extrabold text-background-50 leading-tight max-w-3xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-sm md:text-base text-background-100 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
          {crumbs && crumbs.length > 0 && (
            <nav className="mt-6 flex items-center flex-wrap gap-2 text-xs md:text-sm">
              {crumbs.map((c, idx) => (
                <span key={`${c.label}-${idx}`} className="flex items-center gap-2">
                  {c.to ? (
                    <Link
                      to={c.to}
                      className="text-background-200 hover:text-background-50 cursor-pointer whitespace-nowrap"
                    >
                      {c.label}
                    </Link>
                  ) : (
                    <span className="text-background-50 font-medium whitespace-nowrap">
                      {c.label}
                    </span>
                  )}
                  {idx < crumbs.length - 1 && (
                    <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-300" />
                  )}
                </span>
              ))}
            </nav>
          )}
        </div>
      </div>
    </section>
  );
}